import { EditableType, EditableFileTypes, LegacyEditableTypes } from "shared-utils/enums/editables";

export const EditableEvent = {
    Update: "update",
    Remove: "remove",
    Restore: "restore"
} as const;

export const EditableGroupEvent = {
    Add: "add",
    Update: "update",
    Edit: "edit",
    Remove: "remove",
    Batch: "batch",
    Duplicate: "duplicate",
    ImportFeed: "importFeed",
    RefreshFeed: "refreshFeed",
    DeleteFeed: "deleteFeed"
} as const;

export const EditableTypeWidgetOverrides = {
    backgroundimage: "image",
    subtitles: "file",
    [EditableType.Textarea]: EditableType.Text
} as const;

export const EditableScope = {
    Standalone: "standalone",
    Group: "group"
} as const;

export const ExportableEditableTypes = [
    EditableType.Text,
    EditableType.Textarea,
    LegacyEditableTypes.Subtitles,
    ...EditableFileTypes,
    EditableType.Array,
    EditableType.Boolean,
    EditableType.Css
] as const;

export const ExportableTranslationTypes = [
    EditableType.Text,
    EditableType.Textarea,
    LegacyEditableTypes.Subtitles
] as const;

export const EditableSettingProperty = {
    FontColor: "fontColor",
    FontFamily: "fontFamily",
    FontSize: "fontSize",
    FontStyle: "fontStyle",
    FontWeight: "fontWeight",
    Height: "height",
    Left: "left",
    LetterSpacing: "letterSpacing",
    LineHeight: "lineHeight",
    Scale: "scale",
    TranslationMethod: "translationMethod",
    Top: "top",
    Width: "width",
    Font: "font",
    TextAlignment: "textAlignment",
    Tracking: "tracking",
    KerningMethod: "kerningMethod",
    KerningValue: "kerningValue",
    OffsetX: "offsetX",
    OffsetY: "offsetY"
} as const;

export const EditableSettingElementPositionProperty = {
    Width: "width",
    Height: "height",
    Top: "top",
    Left: "left",
    Scale: "scale",
    TranslationMethod: "translationMethod"
} as const;

export const EditableTranslateMethod = {
    Transform: "transform",
    Relative: "relative",
    Margin: "margin",
    BackgroundPosition: "background-position"
} as const;

export const EditablePhotoshopSettings = {
    fontFamily: "fontName",
    letterSpacing: "tracking",
    lineHeight: "leading",
    fontSize: "fontSize",
    fontWeight: "fontWeight",
    textAlignment: "alignment",
    fontColor: "fontColor"
} as const;

export type EditableSettingPropertyValues = (typeof EditableSettingProperty)[keyof typeof EditableSettingProperty];
export type EditablePhotoshopSettingsValues =
    (typeof EditablePhotoshopSettings)[keyof typeof EditablePhotoshopSettings];

export type EditableSettingElementPositionPropertyValues =
    (typeof EditableSettingElementPositionProperty)[keyof typeof EditableSettingElementPositionProperty];
